import React from 'react';
import { faStepForward } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './LastButton.module.css';
import { CommonButton } from '_components';


export class LastButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Last'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faStepForward} transform="shrink-6"/>
            </CommonButton>
        );
    }
}

